import React from 'react'
import { storiesOf } from '@storybook/react'

import { Currency as Currencies } from 'protos'

import Currency from 'components/Currency'

storiesOf('Currency', module)
  .add('default', () => (
    <>
      <Currency value={43654} /><br />
      <Currency value={43654} currency={Currencies.CR_EUR_CENT} /><br />
      <Currency value={43654} currency={Currencies.CR_GBP_CENT} /><br />
      <Currency value={43654} currency={Currencies.CR_USD_CENT} /><br />
      <Currency value={43654} currency={Currencies.CR_HUF} />
    </>
  ))
